/**
 * TikTok uses Geoname IDs for `location_ids`. These are the most common
 * countries Slightor customers target. Match codes match ISO-3166-1 alpha-2
 * for friendly UI; the `id` is what TikTok wants in the API call.
 *
 * Source: https://www.geonames.org/countries — Geoname IDs are the column
 * shown as "GeoNameId" on each country page. TikTok's adgroup `location_ids`
 * accepts these directly.
 */
export interface TiktokGeoCountry {
  code: string;   // ISO-3166-1 alpha-2 (UI hint)
  id: string;     // TikTok location_id (Geoname ID, sent to API)
  label: string;
}

export const TIKTOK_COUNTRIES: TiktokGeoCountry[] = [
  { code: 'AE', id: '290557',  label: 'United Arab Emirates' },
  { code: 'SA', id: '102358',  label: 'Saudi Arabia' },
  { code: 'EG', id: '357994',  label: 'Egypt' },
  { code: 'PK', id: '1168579', label: 'Pakistan' },
  { code: 'IN', id: '1269750', label: 'India' },
  { code: 'US', id: '6252001', label: 'United States' },
  { code: 'GB', id: '2635167', label: 'United Kingdom' },
  { code: 'CA', id: '6251999', label: 'Canada' },
  { code: 'AU', id: '2077456', label: 'Australia' },
  { code: 'DE', id: '2921044', label: 'Germany' },
  { code: 'FR', id: '3017382', label: 'France' },
  { code: 'IT', id: '3175395', label: 'Italy' },
  { code: 'ES', id: '2510769', label: 'Spain' },
  { code: 'BR', id: '3469034', label: 'Brazil' },
  { code: 'MX', id: '3996063', label: 'Mexico' },
  { code: 'ID', id: '1643084', label: 'Indonesia' },
  { code: 'TR', id: '298795',  label: 'Turkey' },
  { code: 'MY', id: '1733045', label: 'Malaysia' },
  { code: 'TH', id: '1605651', label: 'Thailand' },
  { code: 'PH', id: '1694008', label: 'Philippines' },
  { code: 'SG', id: '1880251', label: 'Singapore' },
  { code: 'VN', id: '1562822', label: 'Vietnam' },
  { code: 'JP', id: '1861060', label: 'Japan' },
  { code: 'KR', id: '1835841', label: 'South Korea' },
  { code: 'OM', id: '286963',  label: 'Oman' },
  { code: 'KW', id: '285570',  label: 'Kuwait' },
  { code: 'QA', id: '289688',  label: 'Qatar' },
  { code: 'BH', id: '290291',  label: 'Bahrain' },
  { code: 'JO', id: '248816',  label: 'Jordan' },
];

export const TIKTOK_AGE_GROUPS = [
  { value: 'AGE_13_17',  label: '13–17' },
  { value: 'AGE_18_24',  label: '18–24' },
  { value: 'AGE_25_34',  label: '25–34' },
  { value: 'AGE_35_44',  label: '35–44' },
  { value: 'AGE_45_54',  label: '45–54' },
  { value: 'AGE_55_100', label: '55+' },
];

export const TIKTOK_GENDERS = [
  { value: 'GENDER_UNLIMITED', label: 'All' },
  { value: 'GENDER_MALE',      label: 'Male' },
  { value: 'GENDER_FEMALE',    label: 'Female' },
] as const;
